<template>
  <b-modal
    title="PERMITIR DISPOSITIVO"
    size="md"
    id="modal_add_device"
    no-close-on-backdrop
    no-close-on-esc
    :busy="loading"
    hide-footer
    @show="evOnShow"
    @shown="evOnShown"
    @hide="evOnHide"
  >
    <b-form @submit.prevent="evOnSubmit">
      <b-row>
        <b-col>
          <LabelRequiredField label="Nome" />
          <b-input type="text" ref="autofocus" v-model="name"></b-input>
          <small class="form-text text-muted">Exemplo: Computador Sala 1</small>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <LabelRequiredField label="Código" />
          <b-input type="text" v-model="code"></b-input>
        </b-col>
      </b-row>
      <WarningRequiredFields />
      <ErrorsMessages :errors="errors" />
      <b-row align-h="between">
        <b-col cols="auto">
          <v-btn class="btn-return" @click="$bvModal.hide('modal_add_device')">
            <i class="fa fa-times mr-2 text-twenty"></i>
            CANCELAR
          </v-btn>
        </b-col>
        <b-col cols="auto">
          <v-btn type="submit" class="btn-save">
            <i class="fa fa-check mr-2 text-twenty"></i>
            SALVAR
          </v-btn>
        </b-col>
      </b-row>
    </b-form>
  </b-modal>
</template>

<script>
import ErrorsMessages from "../Components/ErrorsMessages";
import WarningRequiredFields from "../Components/WarningRequiredFields";
import LabelRequiredField from "../Components/LabelRequiredField";
import api from "../../services/api";
import toast from "../../lib/ToastNotification";

export default {
  name: "AddDevice",

  components: {
    ErrorsMessages,
    WarningRequiredFields,
    LabelRequiredField,
  },

  data() {
    return {
      errors: [],
      loading: false,

      name: "",
      code: "",
    };
  },

  methods: {
    async evOnShow() {
      this.errors = [];
      this.loading = false;
      this.name = "";
      this.code = "";
    },

    async evOnShown() {
      this.$refs.autofocus.focus();
    },

    async evOnHide() {},

    async evOnSubmit() {
      try {
        this.loading = true;

        const data = { name: this.name, code: this.code };
        const response = await api.post("/rest-home/device", data);
        const { error, errors, message } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          toast(message, "success");
          this.$emit("created");
          this.$bvModal.hide("modal_add_device");
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style>
</style>
